/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス契約情報
 */
export interface Sgkb575aResGasConInfo {
    /** 
     * 導管事業者コード：半角英数混在
     */
    cndtBusCode?: string;
    /** 
     * 導管事業者名称：全角半角混在
     */
    cndtBusAname?: string;
    /** 
     * 託送供給依頼者小売事業者コード：半角英数混在
     */
    tksIrishKoriCd?: string;
    /** 
     * 託送供給依頼者小売事業者コード名称：全角半角混在
     */
    tksirishRetailerCodeaname?: string;
    /** 
     * ガス供給地点特定番号：半角英数混在
     */
    gasSuppntSpno?: string;
    /** 
     * 指定日検針日区分コード：半角英数混在
     */
    siteiKensinDiv?: string;
    /** 
     * 指定日検針日区分コード名称：全角半角混在
     */
    siteiKensinDivAname?: string;
    /** 
     * 検針日程：半角数字
     */
    kensinSchdl?: string;
    /** 
     * 託送供給契約約款区分コード：半角英数混在
     */
    chargeCategCode?: string;
    /** 
     * 託送供給契約約款区分名称：全角半角混在
     */
    chargeCategCodeAname?: string;
    /** 
     * 転売有無フラグ：半角英数混在
     */
    resaleFlg?: string;
    /** 
     * 転売有無名称：全角半角混在
     */
    resaleFlgAname?: string;
    /** 
     * 転売先事業者コード：半角英数混在
     */
    resaleBusCode?: string;
    /** 
     * 転売先事業者名称：全角半角混在
     */
    resaleBusAname?: string;
    /** 
     * 最終供給事業者コード：半角英数混在
     */
    finalSupplierCode?: string;
    /** 
     * 最終供給事業者名称：全角半角混在
     */
    finalSupplierAname?: string;
    /** 
     * 最終供給事業者連絡先：電話番号(ハイフンと数値含む)
     */
    finalSupplierTel?: string;
    /** 
     * 負荷計測器工事有無フラグ：半角英数混在
     */
    hukakeConstFlg?: string;
    /** 
     * 負荷計測器工事有無名称：全角半角混在
     */
    hukakeConstFlgAname?: string;
    /** 
     * ガスメーター能力：半角数値(小数点あり)
     */
    gasMeterAbility?: number;
    /** 
     * 供給管圧力区分コード：半角英数混在
     */
    supplyPipeAtrkDiv?: string;
    /** 
     * 供給管圧力：全角半角混在
     */
    supplyPipeAtrkAname?: string;
    /** 
     * 廃止取次有無フラグ：半角英数混在
     */
    ablcomFlg?: string;
    /** 
     * 廃止取次有無名称：全角半角混在
     */
    ablcomFlgAname?: string;
    /** 
     * 現小売事業者お客さま番号：半角英数混在
     */
    oldretCustomerNo?: string;
    /** 
     * 閉栓理由区分コード：半角英数混在
     */
    closingRsncod?: string;
    /** 
     * 閉栓理由区分名称：全角半角混在
     */
    closingRsnAname?: string;
    /** 
     * その他特記事項：全角文字
     */
    othersMemo?: string;
    /** 
     * 閉栓作業有無コード：半角英数混在
     */
    turnoffworkUmucode?: string;
    /** 
     * 閉栓作業有無コード名称：全角半角混在
     */
    turnoffworkUmuCodeaname?: string;
    /** 
     * 託送連係有無フラグ：半角英数混在
     */
    tksLinkEonflg?: string;
    /** 
     * 託送連係有無フラグ名称：全角半角混在
     */
    consignmentconnectionUmuFlganame?: string;
    /** 
     * 総合契約区分コード：半角英数混在
     */
    sogoCtrDiv?: string;
    /** 
     * 総合契約区分コード名称：全角半角混在
     */
    combinedcontractDivCodeaname?: string;
    /** 
     * 閉栓種別コード：半角英数混在
     */
    heisenClscode?: string;
    /** 
     * 閉栓種別コード名称：全角半角混在
     */
    heisenClsfyCodeaname?: string;
    /** 
     * 閉栓状態コード：半角英数混在
     */
    heisenStcode?: string;
    /** 
     * 閉栓状態コード名称：全角半角混在
     */
    heisenStateCodeaname?: string;
    /** 
     * 電気契約の案内：半角英数混在
     */
    electricitycontractAnnai?: string;
    /** 
     * 電気契約の案内名称：全角半角混在
     */
    electricitycontractAnnaianame?: string;
    /** 
     * 公団床暖房申込書受領フラグ：半角英数混在
     */
    publiccorporationyukadanboSrndocReceiptflag?: string;
    /** 
     * 公団床暖房申込書受領フラグ名称：全角半角混在
     */
    publiccorporationyukadanboSrndocreceiptFlganame?: string;
    /** 
     * 署名区分：半角英数混在
     */
    signatureDiv?: string;
    /** 
     * 署名区分名称：全角半角混在
     */
    signatureDivaname?: string;
    /** 
     * 販売契約書ファイルパス：半角英数混在
     */
    salescontractdocumentFilepath?: string;
    /** 
     * 開栓時託送種別変更有無フラグ：半角英数混在
     */
    turnontimeChangeinconsignmenttypeEonflg?: string;
    /** 
     * 開栓時託送種別変更有無フラグ名称：全角半角混在
     */
    turnontimeChangeinconsignmenttypeumuFlganame?: string;
    /** 
     * 総合契約マスタ反映イベント登録済フラグ：半角英数混在
     */
    combinedcontractMasterhaneieventRegistrationflag?: string;
    /** 
     * 総合契約マスタ反映イベント登録済フラグ名称：全角半角混在
     */
    combinedcontractMasterhaneieventregistrationFlganame?: string;
    /** 
     * プレミアム単価：半角数値(小数点あり)
     */
    premiumTanka?: number;
    /** 
     * 開栓作業担当社員番号：半角英数混在
     */
    turnonWorkchargeStafno?: string;
    /** 
     * 電気契約有無フラグ：半角英数混在
     */
    electricitycontractEonflg?: string;
    /** 
     * 電気契約有無フラグ名称：全角半角混在
     */
    electricitycontractEonflgAname?: string;
    /** 
     * 小売事業者（現小売）コード：半角英数混在
     */
    currentretailBusinessoperatorcode?: string;
    /** 
     * 総合供給先番号：半角英数混在
     */
    sougouSupplydestinationNo?: string;
    /** 
     * 託送契約月別託送供給量１月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyJan?: number;
    /** 
     * 託送契約月別託送供給量２月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyFeb?: number;
    /** 
     * 託送契約月別託送供給量３月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyMar?: number;
    /** 
     * 託送契約月別託送供給量４月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyApr?: number;
    /** 
     * 託送契約月別託送供給量５月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyMay?: number;
    /** 
     * 託送契約月別託送供給量６月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyJun?: number;
    /** 
     * 託送契約月別託送供給量７月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyJul?: number;
    /** 
     * 託送契約月別託送供給量８月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyAug?: number;
    /** 
     * 託送契約月別託送供給量９月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplySep?: number;
    /** 
     * 託送契約月別託送供給量１０月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyOct?: number;
    /** 
     * 託送契約月別託送供給量１１月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyNov?: number;
    /** 
     * 託送契約月別託送供給量１２月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyDec?: number;
    /** 
     * 保安止め閉開栓結果番号：半角数字
     */
    hoanstopOpenstoptapResultno?: string;
    /** 
     * 料金プラン要確認フラグ：半角英数混在
     */
    priceplanNeedconfirmflag?: string;
    /** 
     * 料金プラン要確認フラグ名称：全角半角混在
     */
    priceplanNeedconfirmFlganame?: string;
    /** 
     * 引継ぎメモ：全角半角混在
     */
    vstinfMemo?: string;
    /** 
     * 初回小売開栓結果登録受付番号：半角数字
     */
    firstRetailkaisenresultresitorAcceptancenumber?: string;
    /** 
     * 導管事業者申請受付番号：半角英数混在
     */
    doknjgyshAppAcceptancenumber?: string;
    /** 
     * 導管事業者申請結果コード：半角英数混在
     */
    doknjgyshAppResultcode?: string;
    /** 
     * 導管事業者受付番号：半角英数混在
     */
    doknjgyshAcceptancenumber?: string;
    /** 
     * 導管事業者受付日：日付YYYYMMDD
     */
    doknjgyshAcceptdate?: string;
}
